import { Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

interface ListStateProps {
  statesList: {
    stateId: number;
    stateName: string;
  }[];
  totalItemCount: number;
  pageIndex: number;
  pageSize: number;
  onChangePageIndex: (pageNumber: number) => void;
  onChangePageSize: (pageSize: number) => void;
  handelDelete: () => void;
  handelEdit: (state: {}) => void;
  // findOptions: any,
  // resetFindOptions: () => void;
  // handleFindState: (findOptions: any) => void;
}

const ListStates: React.FC<ListStateProps> = ({
  statesList,
  totalItemCount,
  pageIndex,
  pageSize,
  onChangePageIndex,
  onChangePageSize,
  handelDelete,
  handelEdit,
  // findOptions,
  // resetFindOptions,
  // handleFindState,
}) => {
  return (
    <>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {statesList.map((state: any, index: number) => (
            <tr key={state.stateId}>
              <td>{state.stateId}</td>
              <td>{state.stateName}</td>
              <td>
                <Button onClick={() => handelEdit(state)}>Edit</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default ListStates;
